import "./ProfileDetails.css";

import {
  faArrowCircleLeft,
  faEdit,
  faPenToSquare,
} from "@fortawesome/free-solid-svg-icons";
import { useAppDispatch, useAppSelector } from "../../../hooks/reduxHooks";

import CustomInput from "../../CustomInput/CustomInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ID } from "../../../models/authModel";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { setAreYouSureVisible } from "../../../store/modals/modalActions";
import { useState } from "react";

interface ProfileDetailsProps {
  email: string;
  setEmail: any;
  mobile: string;
  setMobile: any;
  errors: any;
  setErrors: any;
  onSaveClicked: () => void;
  validateEmail: () => void;
  setProfileSection: (section: any) => void;
  editable: boolean;
  setEditable: React.Dispatch<React.SetStateAction<boolean>>;
}

const ProfileDetails = ({
  email,
  setEmail,
  mobile,
  setMobile,
  errors,
  setErrors,
  onSaveClicked,
  validateEmail,
  setProfileSection,
  editable,
  setEditable,
}: ProfileDetailsProps) => {
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.auth.user);

  return (
    <div className="profile-details-container">
      <div className="view-profile-container">
        {window.innerWidth <= 480 ? (
          <div
            className="profile-details-header"
            onClick={() => setProfileSection(null)}
          >
            <FontAwesomeIcon icon={faArrowLeft} size="1x" color="#18283c" />
            <p>Personal Details</p>
          </div>
        ) : null}
        <div className="profile-top">
          <div className="profile-item">
            <p className="profile-label">FULL NAME & SURNAME</p>
            <p className="profile-value">{user?.full_name}</p>
          </div>
          <div className="profile-id-container">
            <div className="profile-item">
              <p className="profile-label">DOCUMENT TYPE</p>
              <p className="profile-value">
                {user?.id_type === 1 ? ID.SA_ID : ID.PASSPORT}
              </p>
            </div>
            <div className="profile-item">
              {user?.id_type === 1 ? (
                <p className="profile-label">ID NUMBER</p>
              ) : (
                <p className="profile-label">PASSPORT NUMBER</p>
              )}
              <p className="profile-value">{user?.id_number}</p>
            </div>
            <FontAwesomeIcon
              className="edit-icon"
              icon={faPenToSquare}
              size="3x"
              color="#18283c"
              style={{ opacity: 0 }}
            />
          </div>
          <div className="profile-divider" />
          <div className="profile-contact-details">
            <p className="profile-label">CONTACT DETAILS</p>
            {!editable ? (
              <FontAwesomeIcon
                icon={faEdit}
                size="1x"
                color="#18283c"
                className="edit-profile-button"
                onClick={() => setEditable(true)}
              />
            ) : null}
          </div>

          <div className="edit-profile-input-container">
            <CustomInput
              label="EMAIL ADDRESS"
              placeholder={user?.email!}
              defaultValue={user?.email!}
              setValue={setEmail}
              onBlur={validateEmail}
              disabled={!editable}
              id="email-input"
              inputStyle={{ backgroundColor: editable ? "white" : "#f2f2f2" }}
            />
            <CustomInput
              label="MOBILE NUMBER"
              id="mobile-input"
              type="tel"
              placeholder={user?.mobile_number}
              defaultValue={user?.mobile_number}
              setValue={setMobile}
              containerStyle={{ marginTop: 20, marginBottom: 20 }}
              maxLength={10}
              pattern="[0-9]{10}"
              disabled={!editable}
              inputStyle={{ backgroundColor: editable ? "white" : "#f2f2f2" }}
            />
            {editable ? (
              <div
                className="profile-save-button"
                onClick={() =>
                  email !== user?.email &&
                  /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)
                    ? dispatch(setAreYouSureVisible(true))
                    : /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)
                    ? onSaveClicked()
                    : null
                }
              >
                <p>Save</p>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileDetails;
